import moment from 'moment';

const tableDespatch = {
    loading: false,
    data: [],
    fields: [],
    fieldSubTable: [
        {
            key: 'product.code',
            label: 'Codigo'
        },
        {
            key: 'brand.description',
            label: 'Marca'
        },
        {
            key: 'product.description',
            label: 'Descripción'
        },
        {
            key: 'ubi',
            label: 'Ubicación',
            variant: 'success'
        },
        {
            key: 'backorder_quantity',
            label: 'Cant',
            tdClass: 'text-center'
        },
        {
            key: 'Num_-_Lote',
            label: 'Num - Lote'
        },
        {
            key: 'enlisted',
            label: 'Alistado'
        },
        {
            key: 'product.weight',
            label: 'Peso'
        },
        {
            key: 'unit_value_before_taxes',
            label: 'Vr-Unitario'
        },
        {
            key: 'total_value_brut',
            label: 'Vr-Bruto'
        },
        {
            key: 'total_value_iva',
            label: 'Vr-IVA'
        },
        {
            key: 'total_value',
            label: 'Vr-Total'
        }
    ],
    errors: {
        has: false,
        message: '',
        code: 0,
        data: []
    },
    pagination: [],
    options: {
        zone_id: '',
        perPage: 100,
        search: '',
        currentPage: 1,
        date: [],
        state_despatch_id: null,
        guide: null,
        protractor: null,
        contact_id: null,
        consecutive: null


    }
};

var tableDocumentsProductsLot = {
    data: [],
    dataFilter: [],
    brands: [],
    brandsSelected: null,
    fields: [
        {
            key: 'product.code',
            label: 'Codigo'
        },
        {
            key: 'product.description',
            label: 'Descripción'
        },
        {
            key: 'products_lots.num_lot',
            label: 'Num Lote'
        },
        {
            key: 'products_lots.expiration_date',
            label: 'Fecha Vencimiento'
        }
    ]
};

export const documentProduct = () => {
    return {
        id: null,
        product_id: null,
        product: {
            code: null,
            description: null,
            product_attachment_main: {

            }
        },
        quantity: null,
        pack_quantity: 0
    }
}

export default {
    contact_branchoffices: [],
    contacts: [],
    invoices: {
        data: []
    },
    preloader: false,
    stickers: null,
    invoice: {
        id: null,
        contact: {},
        number_stickers: null,
        documents_products:[],
        weight:null,
        volume:null,
    },
    document_product:documentProduct(),
    default_document_product:documentProduct(),
    modal_packing: {
        show: false
    },
    paramsquery: {
        is_customer: false,
        is_provider: false,
        is_employee: false,
        filter_customer: [],
        filter_provider: [],
        filter_employee: [],
        paginate: true,
        page: 1,
        perPage: 50,
        query: '',
        sortBy: 'id',
        sort: 'ASC',
    },
    despatchInvoiceList: [],
    action: 'create',
    //ERROR STATE
    error: false,
    errorMessage: '',
    // Tabla
    conyevors: [],
    tableDespatch,
    tableDocumentsProductsLot,
    contactZone: [],
    states: [],
    params: {
        dates: [
            moment().format('YYYY-MM-DD'),
            moment().format('YYYY-MM-DD')
        ],
        state_despatch_id: null,
        contact_id: null,
        guide: null,
        protractor_id: null,
        consecutive: null,
        contact_branchoffice_id: null,
        page: 1,
        per_page: 30
    },
    loading_report_butons: {
        print_sticker: false,
        excel_despatch: false,
        excel_pickin: false,
        pdf_pickin: false,
        pdf_proactor: false,
    },
    document_product_modal: null,
    loading: {
        module:false,
    },
    modalPdfPackingShow: false,
    pdfPathPacking: ""
};



// WEBPACK FOOTER //
// ./src/modules/despatch-packing/state.js